import * as React from 'react';
import { useImperativeHandle } from 'react';
import { Typography, ListItem, ListItemText, ListItemIcon, ListItemButton } from '@mui/material';
import { Box } from '@mui/material';
import VerticalHamburgerMenu from '../../common/controls/VerticalHamburgerMenu';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';
import { useHistoryInventoryTransactions } from '../../../hooks/inventory/useHistoryInventoryTransactions';
import InventoryTransactionView from '../../inventory/modals/InventoryTransactionView';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';
import ShoppingCart from '../modals/ShoppingCart';
import { userHasAccess } from '../../../utils/userHasAccess';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function TransactionsListItems({ setListEmpty, setDoneLoading = null, history = null, historyEntry = null, pet = null, ref }) {
  const { t } = useTranslation('common');
  const { showSnackbar } = useSnackbar();

  const { transactions, loading, loadMore, searchFunction, resetParent } =
    useHistoryInventoryTransactions(history.id, historyEntry?.id || null);

  const [selectedTransaction, setSelectedTransaction] = React.useState(null);
  const [transactionViewOpen, setTransactionViewOpen] = React.useState(false);
  const [shoppingCartOpen, setShoppingCartOpen] = React.useState(false);

  const handleShoppingCartOpen = () => setShoppingCartOpen(true);
  useImperativeHandle(ref, () => ({ handleShoppingCartOpen }));

  const handleListItemClick = (transaction) => {
    setSelectedTransaction(transaction);
    setTransactionViewOpen(true);
  };

  const onShoppingCartCheckoutSuccess = () => {
    setShoppingCartOpen(false);
    resetParent();
  };

  React.useEffect(() => {
    if (transactions.data.length !== 0) {
      setListEmpty(false);
    }
  }, [transactions]);

  React.useEffect(() => {
    if (!loading)
    {
      if (setDoneLoading) setDoneLoading(true);
    }
  }, [loading]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
        transactions?.data.map((transaction) => (
          <ListItem
            key={"transaction" + transaction.id}
            sx={{ py: 0 }}
            alignItems="flex-start"
            secondaryAction={
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <VerticalHamburgerMenu
                  options={[
                    {
                      id: 1,
                      name: 'View',
                      callback: () => handleListItemClick(transaction),
                      disabled: !userHasAccess(SUB_MODULES.INVENTORY, 1)
                    },
                  ]}
                />
              </Box>
            }
          >
            <ListItemButton sx={{ py: 0 }} onClick={() => {if (userHasAccess(SUB_MODULES.INVENTORY, 1)) handleListItemClick(transaction)}}>
              <ListItemIcon>
                <CompareArrowsIcon fontSize="medium" color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body2" sx={{ maxWidth: '90%' }}>
                    {transaction.item.name}
                  </Typography>
                }
                secondary={
                  <Typography component="span" variant="body2" color="text.secondary">
                    {`${transaction.flow === 'in' ? "+" : "-"}${removeZeroDecimals(transaction.quantity)}${transaction.item.uom} ${transaction.transactionType.name}`}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        ))
      )}

      <InventoryTransactionView
        transaction={selectedTransaction}
        open={transactionViewOpen}
        onClose={() => setTransactionViewOpen(false)}
      />
      <ShoppingCart
        successCallback={onShoppingCartCheckoutSuccess}
        history={history}
        historyEntry={historyEntry}
        pet={pet}
        open={shoppingCartOpen}
        onClose={() => setShoppingCartOpen(false)}
      />
    </>
  );
}